/***
*
*   AUTH LAYOUT
*   Layout for the signup/signin pages
*
**********/

import { HomeNav, Footer, useTranslation } from 'components/lib';
import Style from './auth.tailwind.js';

export function AuthLayout(props) {
  const { t } = useTranslation();

  return (
    <main className={Style.auth}>
      <HomeNav hideNavItems={props.hideNavItems} />
      {<props.children t={t} />}
      <Footer />
    </main>
  );
}